import { Button } from "antd";
import React from "react";
import { FaCheck } from "react-icons/fa";

const CalibrationDoneStep = ({ onDone, onClose }) => {

    const handleClose = () => {
        if (onDone) {
            onDone();
        }
    };

    return (
        <div className="calibration-done-step">
            <button
                type="button"
                className="calibration-done-step__close"
                onClick={handleClose}
            >
                ✕
            </button>

            <div className="calibration-done-step__content">
                <div className="calibration-done-step__icon">
                    <FaCheck />
                </div>

                <h1>Calibración completada</h1>

                <p>
                    La configuración se aplicó correctamente. Ya puedes trabajar sobre la
                    imagen y comenzar a definir los asientos con la escala adecuada.
                </p>
            </div>

            <div className="calibration-done-step__actions">
                <Button type="link" onClick={onDone}>
                    Finalizar
                </Button>
            </div>
        </div>
    );
};

export { CalibrationDoneStep };